/* Sharrow Test Drive: hero stats, test library, and homepage teaser.
   Every number is derived from window.SHARROW_FLOW_REPORTS (assets/sharrow-flow-data.js):
   speeds/RPM are the report's measured data; slip is calculated (1 - speed / pitch speed). */
(function(){
  const reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
  const clamp=(v,a,b)=>Math.max(a,Math.min(b,v));
  const esc=s=>String(s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const fmtRpm=r=>(Math.round(r/50)*50).toLocaleString('en-US');
  const reports=()=>Array.isArray(window.SHARROW_FLOW_REPORTS)?window.SHARROW_FLOW_REPORTS:[];

  function interp(pts,r){
    if(r<=pts[0][0]) return pts[0][1]*Math.max(0,r)/pts[0][0];
    for(let i=1;i<pts.length;i++){if(r<=pts[i][0]){const a=pts[i-1],b=pts[i];return a[1]+(b[1]-a[1])*(r-a[0])/(b[0]-a[0]);}}
    return pts[pts.length-1][1];
  }
  const k=rep=>rep.units==='kn'?1.15078:1;
  const mph=(rep,prop,r)=>interp(prop.pts,r)*k(rep);
  const slip=(rep,prop,r)=>{const vth=r/rep.gr*prop.p/1056;return vth>0?clamp(1-mph(rep,prop,r)/vth,0,0.95):0;};
  function brandOf(rep){const m=/(Mercury|Yamaha|Suzuki|OXE|Cox)/i.exec(rep.engine);if(!m) return 'Other';const b=m[1].toUpperCase();return b==='OXE'?'OXE Diesel':b==='COX'?'Cox Diesel':m[1][0].toUpperCase()+m[1].slice(1).toLowerCase();}
  function enginesOf(rep){const s=rep.engine;return /quint/i.test(s)?5:/quad/i.test(s)?4:/triple/i.test(s)?3:/twin/i.test(s)?2:1;}

  const cache={};
  function summary(rep){
    if(cache[rep.id]) return cache[rep.id];
    const S=rep.sharrow,C=rep.conv;
    const lo=Math.max(S.pts[0][0],C.pts[0][0]),hi=Math.min(S.pts[S.pts.length-1][0],C.pts[C.pts.length-1][0]);
    let best={gain:-1e9,r:lo};
    for(let r=lo;r<=hi;r+=50){const g=mph(rep,S,r)-mph(rep,C,r);if(g>best.gain) best={gain:g,r};}
    /* Report the gain at a measured RPM point when one is close, so cards match the published charts. */
    const measured=S.pts.map(p=>p[0]).filter(r=>C.pts.some(q=>q[0]===r));
    let mBest=null;measured.forEach(r=>{const g=mph(rep,S,r)-mph(rep,C,r);if(!mBest||g>mBest.gain) mBest={gain:g,r};});
    if(mBest&&mBest.gain>=best.gain-0.6) best=mBest;
    const vs=mph(rep,S,best.r),vc=mph(rep,C,best.r);
    const ss=slip(rep,S,best.r),sc=slip(rep,C,best.r);
    const rmin=Math.max(500,Math.min(S.pts[0][0],C.pts[0][0])),rmax=Math.max(S.pts[S.pts.length-1][0],C.pts[C.pts.length-1][0]);
    const top={s:S.pts[S.pts.length-1][1]*k(rep),c:C.pts[C.pts.length-1][1]*k(rep)};
    return cache[rep.id]={gain:best.gain,r:best.r,pct:vc>0?best.gain/vc*100:0,vs,vc,ss,sc,slipCut:sc-ss,rmin,rmax,top,
      brand:brandOf(rep),engines:enginesOf(rep),throttle:(best.r-rmin)/(rmax-rmin)};
  }

  /* Speed gained by SHARROW at every 500 RPM, drawn as bars on one fixed scale for every test
     (0 to +20 mph), so a bigger mid-range advantage looks bigger. */
  const GAIN_MAX=20;
  function gainSeries(rep){
    const S=rep.sharrow,C=rep.conv;
    const lo=Math.max(S.pts[0][0],C.pts[0][0],1000),hi=Math.min(S.pts[S.pts.length-1][0],C.pts[C.pts.length-1][0]);
    const out=[];for(let r=Math.ceil(lo/500)*500;r<=hi;r+=500) out.push({r,g:mph(rep,S,r)-mph(rep,C,r)});
    return out;
  }
  function gainBars(rep,sum){
    const bars=gainSeries(rep);if(!bars.length) return '';
    const W=300,H=118,padL=26,padR=6,padT=18,padB=18,pw=W-padL-padR,ph=H-padT-padB;
    const top=Math.max(GAIN_MAX,Math.ceil(Math.max(...bars.map(b=>b.g))/5)*5);
    const minG=Math.min(0,...bars.map(b=>b.g)),bot=minG<0?Math.max(-10,Math.floor(minG/5)*5):0;
    const r0=bars[0].r-250,r1=bars[bars.length-1].r+250;
    const X=r=>padL+(r-r0)/(r1-r0)*pw,Y=g=>padT+(top-clamp(g,bot,top))/(top-bot)*ph;
    const bw=Math.min(22,pw/bars.length*0.7);
    let peak=bars[0];bars.forEach(b=>{if(b.g>peak.g) peak=b;});
    let o='<svg class="td-gain" viewBox="0 0 '+W+' '+H+'" role="img" aria-label="Biggest gain '+(peak.g>=0?'+':'')+peak.g.toFixed(1)+' mph at '+fmtRpm(peak.r)+' RPM">';
    const m0=Math.max(2500,bars[0].r),m1=Math.min(4500,bars[bars.length-1].r);
    if(m1>=m0) o+='<rect class="tg-mid" x="'+(X(m0)-bw/2-3).toFixed(1)+'" y="'+(padT-2)+'" width="'+(X(m1)-X(m0)+bw+6).toFixed(1)+'" height="'+(ph+2)+'" rx="5"/>';
    [10,20].forEach(g=>{if(g<=top){const y=Y(g).toFixed(1);o+='<line class="tg-grid" x1="'+padL+'" x2="'+(W-padR)+'" y1="'+y+'" y2="'+y+'"/><text class="tg-yl" x="'+(padL-4)+'" y="'+(+y+3).toFixed(1)+'" text-anchor="end">+'+g+'</text>';}});
    o+='<line class="tg-zero" x1="'+padL+'" x2="'+(W-padR)+'" y1="'+Y(0).toFixed(1)+'" y2="'+Y(0).toFixed(1)+'"/>';
    bars.forEach(b=>{const y0=Y(0),y1=Y(b.g);o+='<rect class="tg-bar'+(b.g<0?' tg-neg':'')+(b===peak?' tg-peak':'')+'" x="'+(X(b.r)-bw/2).toFixed(1)+'" y="'+Math.min(y0,y1).toFixed(1)+'" width="'+bw.toFixed(1)+'" height="'+Math.max(1,Math.abs(y1-y0)).toFixed(1)+'" rx="2"/>';});
    o+='<text class="tg-peakt" x="'+X(peak.r).toFixed(1)+'" y="'+(Y(peak.g)-4).toFixed(1)+'" text-anchor="middle">+'+peak.g.toFixed(1)+'</text>';
    bars.forEach(b=>{if(b.r%1000===0) o+='<text class="tg-xl" x="'+X(b.r).toFixed(1)+'" y="'+(H-5)+'" text-anchor="middle">'+(b.r/1000)+'k</text>';});
    return o+'</svg>';
  }

  function testDriveHref(base,rep,sum){return base+'?test='+encodeURIComponent(rep.id)+'&rpm='+Math.round(sum.r)+'#sflow-sim';}

  function card(rep,sum,mode,base){
    const sign=sum.gain>=0?'+':'−';
    const gainTxt=sign+Math.abs(sum.gain).toFixed(1)+' mph';
    const engTag=sum.engines===1?'Single':sum.engines===2?'Twin':sum.engines===3?'Triple':sum.engines===4?'Quad':'Quint';
    const head='<div class="td-card-top"><h3>'+esc(rep.name)+'</h3><p>'+esc(rep.engine)+'</p></div>';
    const metrics='<div class="td-card-metrics">'+
      '<div class="td-m td-m-gain"><b>'+gainTxt+'</b><span>at '+fmtRpm(sum.r)+' RPM ('+sign+Math.abs(sum.pct).toFixed(0)+'%)</span></div>'+
      '<div class="td-m"><b><i class="td-s">'+Math.round(sum.ss*100)+'%</i><em> vs </em><i class="td-c">'+Math.round(sum.sc*100)+'%</i></b><span>slip at that RPM</span></div></div>';
    const chart='<div class="td-card-chart"><div class="td-card-legend"><span class="td-s">MPH gained with SHARROW™</span><span class="td-ax"><i class="td-midkey"></i>Mid-range</span></div>'+gainBars(rep,sum)+'</div>';
    if(mode==='teaser'){
      return '<a class="td-card td-card-teaser" href="'+esc(testDriveHref(base,rep,sum))+'">'+head+chart+metrics+'<span class="td-card-go">Test drive this <span aria-hidden="true">→</span></span></a>';
    }
    return '<article class="td-card" data-id="'+esc(rep.id)+'">'+
      '<div class="td-tags"><span>'+esc(sum.brand)+'</span><span>'+engTag+'</span></div>'+head+chart+metrics+
      '<p class="td-card-props"><span class="td-s">'+esc(rep.sharrow.label)+'</span> vs <span class="td-c">'+esc(rep.conv.label)+'</span></p>'+
      '<div class="td-card-actions"><button type="button" class="td-btn td-btn-primary td-btn-sm" data-td-load="'+esc(rep.id)+'">Test drive this <span aria-hidden="true">↑</span></button>'+
      '<a class="td-card-report" href="'+esc(rep.url)+'">Report →</a></div></article>';
  }

  function scrollToEl(el){if(el) el.scrollIntoView({behavior:reduceMotion.matches?'auto':'smooth',block:'start'});}

  function initHero(root){
    const R=reports();if(!R.length) return;
    const set=(k,v)=>{const el=root.querySelector('[data-td-stat="'+k+'"]');if(el) el.textContent=v;};
    set('tests',String(R.length));
    set('boats',String(new Set(R.map(r=>r.name.replace(/\s*\(.*\)$/,''))).size));
    let best=null;R.forEach(r=>{const s=summary(r);if(!best||s.gain>best.s.gain) best={r,s};});
    if(best){set('maxgain','+'+best.s.gain.toFixed(1)+' mph');set('maxgain-note','faster at the same RPM ('+best.r.name.replace(/\s*\(.*\)$/,'')+', '+fmtRpm(best.s.r)+' RPM)');}
    root.querySelectorAll('[data-td-scroll]').forEach(a=>a.addEventListener('click',e=>{const t=document.querySelector(a.getAttribute('href'));if(t){e.preventDefault();scrollToEl(t);}}));
  }

  function initLibrary(root){
    const R=reports();if(!R.length){root.hidden=true;return;}
    const grid=root.querySelector('[data-td-grid]'),count=root.querySelector('[data-td-count]'),empty=root.querySelector('[data-td-empty]');
    const search=root.querySelector('[data-td-search]'),sort=root.querySelector('[data-td-sort]');
    const brandBox=root.querySelector('[data-td-brand]'),setupBox=root.querySelector('[data-td-setup]');
    const pageSize=()=>window.matchMedia('(max-width: 760px)').matches?6:9;
    const state={q:'',brand:'All',setup:'All',sort:'gain',shown:pageSize()};
    const more=document.createElement('button');more.type='button';more.className='td-btn td-btn-ghost td-more';grid.after(more);
    more.addEventListener('click',()=>{state.shown+=pageSize();render(true);});
    const brands=['All',...Array.from(new Set(R.map(r=>summary(r).brand))).sort()];
    const setups=[['All','All'],['1','Single'],['2','Twin'],['3+','Triple+']];
    const chips=(box,items,key)=>{
      box.innerHTML=items.map(([v,l])=>'<button type="button" data-v="'+esc(v)+'" aria-pressed="'+(state[key]===v)+'">'+esc(l)+'</button>').join('');
      box.addEventListener('click',e=>{const b=e.target.closest('button');if(!b) return;state[key]=b.dataset.v;box.querySelectorAll('button').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));state.shown=pageSize();render();});
    };
    chips(brandBox,brands.map(b=>[b,b]),'brand');
    chips(setupBox,setups,'setup');
    search.addEventListener('input',()=>{state.q=search.value.trim().toLowerCase();state.shown=pageSize();render();});
    sort.addEventListener('change',()=>{state.sort=sort.value;state.shown=pageSize();render();});

    function render(appending){
      let list=R.filter(r=>{
        const s=summary(r);
        if(state.brand!=='All'&&s.brand!==state.brand) return false;
        if(state.setup==='1'&&s.engines!==1) return false;
        if(state.setup==='2'&&s.engines!==2) return false;
        if(state.setup==='3+'&&s.engines<3) return false;
        if(state.q){const hay=(r.name+' '+r.engine+' '+r.sharrow.label+' '+r.conv.label).toLowerCase();if(!state.q.split(/\s+/).every(t=>hay.includes(t))) return false;}
        return true;
      });
      const by={gain:(a,b)=>summary(b).gain-summary(a).gain,pct:(a,b)=>summary(b).pct-summary(a).pct,slip:(a,b)=>summary(b).slipCut-summary(a).slipCut,
        top:(a,b)=>Math.max(summary(b).top.s,summary(b).top.c)-Math.max(summary(a).top.s,summary(a).top.c),name:(a,b)=>a.name.localeCompare(b.name)};
      list.sort(by[state.sort]);
      const total=list.length,shown=Math.min(total,state.shown);
      const prev=appending?grid.children.length:0;
      grid.innerHTML=list.slice(0,shown).map(r=>card(r,summary(r),'library')).join('');
      if(appending&&grid.children[prev]){const b=grid.children[prev].querySelector('[data-td-load]');if(b) b.focus({preventScroll:true});}
      count.textContent=(total===R.length?'Showing '+shown+' of '+total+' tests':'Showing '+shown+' of '+total+' matching tests');
      more.hidden=shown>=total;more.textContent='Show '+Math.min(pageSize(),total-shown)+' more tests ('+(total-shown)+' left)';
      empty.hidden=list.length>0;
      markActive();
    }
    const sim=()=>document.querySelector('[data-sharrow-flow]');
    let activeId='';
    function markActive(){grid.querySelectorAll('.td-card').forEach(c=>{const on=c.dataset.id===activeId;c.classList.toggle('is-active',on);const b=c.querySelector('[data-td-load]');if(b) b.innerHTML=on?'Loaded in simulator <span aria-hidden="true">↑</span>':'Test drive this <span aria-hidden="true">↑</span>';});}
    document.addEventListener('sflow:report',e=>{activeId=e.detail&&e.detail.id||'';markActive();});
    grid.addEventListener('click',e=>{
      const b=e.target.closest('[data-td-load]');if(!b) return;
      const rep=R.find(r=>r.id===b.dataset.tdLoad);if(!rep) return;
      const s=summary(rep), el=sim();
      try{const u=new URL(window.location.href);u.searchParams.set('test',rep.id);u.searchParams.set('rpm',String(Math.round(s.r)));u.hash='sflow-sim';history.replaceState(null,'',u.toString());}catch(err){}
      if(el&&typeof el.sflowLoad==='function'){el.sflowLoad(rep.id,s.throttle);scrollToEl(el);}
      else window.location.href=testDriveHref(window.location.pathname,rep,s);
    });
    render();
  }

  function initTeaser(root){
    const R=reports();if(!R.length){root.hidden=true;return;}
    const base=root.hasAttribute('data-td-url')?root.getAttribute('data-td-url'):'/pages/test-drive';
    const boatOf=r=>r.name.replace(/\s*\(.*\)$/,'');
    const sorted=R.slice().sort((a,b)=>summary(b).gain-summary(a).gain);
    const seenBoat=new Set(),seenBrand=new Set(),pick=[];
    /* the three biggest gains, one per engine brand first so the teaser shows variety */
    for(const r of sorted){const b=boatOf(r),br=summary(r).brand;if(pick.length<3&&!seenBoat.has(b)&&!seenBrand.has(br)){pick.push(r);seenBoat.add(b);seenBrand.add(br);}}
    for(const r of sorted){if(pick.length>=3) break;const b=boatOf(r);if(!seenBoat.has(b)){pick.push(r);seenBoat.add(b);}}
    const g=root.querySelector('[data-td-teaser-grid]');
    if(g) g.innerHTML=pick.map(r=>card(r,summary(r),'teaser',base)).join('');
    const n=root.querySelector('[data-td-teaser-count]');if(n) n.textContent=String(R.length);
  }

  function boot(){
    document.querySelectorAll('[data-td-hero]').forEach(initHero);
    document.querySelectorAll('[data-td-library]').forEach(initLibrary);
    document.querySelectorAll('[data-td-teaser]').forEach(initTeaser);
  }
  window.SharrowTestDrive={summary};
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
})();
